import { baseApi } from '@/store/api/baseApi';
import type { SiteSeoSettings } from '@/types/seo';

export const seoApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSeoSettings: builder.query<SiteSeoSettings, void>({
      query: () => '/seo',
      providesTags: [{ type: 'Seo', id: 'SITE' }],
    }),
    updateSeoSettings: builder.mutation<SiteSeoSettings, SiteSeoSettings>({
      query: (body) => ({
        url: '/seo/update',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'Seo', id: 'SITE' }],
    }),
  }),
});

export const { useGetSeoSettingsQuery, useUpdateSeoSettingsMutation } = seoApi;
